"use strict";
/**
 * CarboWaste API Client
 * Handles communication with internal CarboWaste services
 *
 * Features:
 * - Contact/support message sending
 * - Excel template loading
 * - Subscription management
 * - Company management
 * - Application Insights telemetry (optional)
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarboWasteApiClient = void 0;
var applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
var endpoints_1 = require("../config/endpoints");
/**
 * Default localization function (returns keys as-is)
 */
var defaultLocalization = function (key) { return key; };
var CarboWasteApiClient = /** @class */ (function () {
    function CarboWasteApiClient(config, localizationFn) {
        var _a;
        this.config = config;
        this.localize = localizationFn || defaultLocalization;
        this.endpoints = (0, endpoints_1.createCarboWasteEndpoints)(config.baseUrl);
        if ((_a = config.appInsights) === null || _a === void 0 ? void 0 : _a.instrumentationKey) {
            this.appInsights = new applicationinsights_web_1.ApplicationInsights({
                config: {
                    instrumentationKey: config.appInsights.instrumentationKey
                }
            });
            this.appInsights.loadAppInsights();
        }
    }
    /**
     * Send contact/support message
     */
    CarboWasteApiClient.prototype.sendContactMessage = function (contactRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var controller_1, timeoutId, response, errorText, error_1, isLocalhost, errorMessage;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 4, , 5]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'CarboWasteApi_SendContactMessage_Started',
                            properties: {
                                endpoint: this.endpoints.SendMessage,
                                userEmail: contactRequest.Email,
                                subject: contactRequest.Subject
                            }
                        });
                        controller_1 = new AbortController();
                        timeoutId = setTimeout(function () { return controller_1.abort(); }, 15000);
                        return [4 /*yield*/, fetch(this.endpoints.SendMessage, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "Accept": "application/json"
                                },
                                body: JSON.stringify(contactRequest),
                                signal: controller_1.signal
                            })];
                    case 1:
                        response = _e.sent();
                        clearTimeout(timeoutId);
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 2:
                        errorText = _e.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'CarboWasteApi_SendContactMessage_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorText: errorText,
                                endpoint: this.endpoints.SendMessage
                            }
                        });
                        throw new Error("".concat(this.localize('contact_error_send_failed'), ": ").concat(response.status, " ").concat(response.statusText));
                    case 3:
                        (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                            name: 'CarboWasteApi_SendContactMessage_Success',
                            properties: {
                                endpoint: this.endpoints.SendMessage,
                                userEmail: contactRequest.Email
                            }
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _e.sent();
                        isLocalhost = this.endpoints.SendMessage.includes('localhost') ||
                            this.endpoints.SendMessage.includes('127.0.0.1');
                        errorMessage = this.localize('contact_error_send_failed');
                        if (error_1 instanceof TypeError && error_1.message.includes('Failed to fetch')) {
                            errorMessage = isLocalhost ?
                                this.localize('api_error_connection_local') :
                                this.localize('api_error_connection_azure');
                        }
                        else if (error_1.name === 'AbortError') {
                            errorMessage = isLocalhost ?
                                this.localize('api_error_timeout_local') :
                                this.localize('api_error_timeout_azure');
                        }
                        else if (error_1 instanceof Error && error_1.message.includes(this.localize('contact_error_send_failed'))) {
                            errorMessage = error_1.message;
                        }
                        (_d = this.appInsights) === null || _d === void 0 ? void 0 : _d.trackException({
                            exception: error_1,
                            properties: {
                                method: 'sendContactMessage',
                                endpoint: this.endpoints.SendMessage,
                                isLocalhost: isLocalhost.toString(),
                                errorType: error_1.name || 'unknown'
                            }
                        });
                        throw new Error(errorMessage);
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Load Excel template from API
     */
    CarboWasteApiClient.prototype.loadTemplate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var controller_2, timeoutId, response, errorText, result, error_2, isLocalhost, errorMessage;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 5, , 6]);
                        (_a = this.appInsights) === null || _a === void 0 ? void 0 : _a.trackEvent({
                            name: 'CarboWasteApi_LoadTemplate_Started',
                            properties: {
                                endpoint: this.endpoints.StartSheet
                            }
                        });
                        console.log('📥 Fetching template from API...');
                        controller_2 = new AbortController();
                        timeoutId = setTimeout(function () { return controller_2.abort(); }, 30000);
                        return [4 /*yield*/, fetch(this.endpoints.StartSheet, {
                                method: 'GET',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                signal: controller_2.signal
                            })];
                    case 1:
                        response = _f.sent();
                        clearTimeout(timeoutId);
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.text().catch(function () { return 'Unable to read error response'; })];
                    case 2:
                        errorText = _f.sent();
                        (_b = this.appInsights) === null || _b === void 0 ? void 0 : _b.trackEvent({
                            name: 'CarboWasteApi_LoadTemplate_HttpError',
                            properties: {
                                status: response.status.toString(),
                                statusText: response.statusText,
                                errorText: errorText,
                                endpoint: this.endpoints.StartSheet
                            }
                        });
                        throw new Error("Template loading failed: ".concat(response.status, " ").concat(response.statusText));
                    case 3: return [4 /*yield*/, response.json()];
                    case 4:
                        result = _f.sent();
                        if (!result.isSuccess) {
                            (_c = this.appInsights) === null || _c === void 0 ? void 0 : _c.trackEvent({
                                name: 'CarboWasteApi_LoadTemplate_ApiError',
                                properties: {
                                    errorMessage: result.errorMessage || 'Unknown API error',
                                    endpoint: this.endpoints.StartSheet
                                }
                            });
                            throw new Error(result.errorMessage || 'API error - no details provided');
                        }
                        console.log("\u2705 Fetched data: ".concat(result.data.cells.items.length, " cells from sheet \"").concat(result.data.sheetName, "\""));
                        (_d = this.appInsights) === null || _d === void 0 ? void 0 : _d.trackEvent({
                            name: 'CarboWasteApi_LoadTemplate_Success',
                            properties: {
                                endpoint: this.endpoints.StartSheet,
                                sheetName: result.data.sheetName,
                                cellCount: result.data.cells.items.length.toString()
                            }
                        });
                        console.log('✅ Template loaded successfully!');
                        return [2 /*return*/, result.data];
                    case 5:
                        error_2 = _f.sent();
                        isLocalhost = this.endpoints.StartSheet.includes('localhost') ||
                            this.endpoints.StartSheet.includes('127.0.0.1');
                        errorMessage = 'Template loading failed';
                        if (error_2 instanceof TypeError && error_2.message.includes('Failed to fetch')) {
                            errorMessage = isLocalhost ?
                                'Connection error - local server not running' :
                                'Connection error - unable to reach API';
                        }
                        else if (error_2.name === 'AbortError') {
                            errorMessage = isLocalhost ?
                                'Timeout - local server not responding' :
                                'Timeout - API not responding';
                        }
                        else if (error_2 instanceof Error && error_2.message) {
                            errorMessage = error_2.message;
                        }
                        (_e = this.appInsights) === null || _e === void 0 ? void 0 : _e.trackException({
                            exception: error_2,
                            properties: {
                                method: 'loadTemplate',
                                endpoint: this.endpoints.StartSheet,
                                isLocalhost: isLocalhost.toString(),
                                errorType: error_2.name || 'unknown'
                            }
                        });
                        console.error('❌ Error loading template:', errorMessage);
                        throw new Error(errorMessage);
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Health check endpoint
     */
    CarboWasteApiClient.prototype.healthCheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(this.endpoints.HealthCheck, {
                                method: 'GET',
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.ok];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return CarboWasteApiClient;
}());
exports.CarboWasteApiClient = CarboWasteApiClient;
//# sourceMappingURL=CarboWasteApiClient.js.map